import * as React from "react";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography/Typography";
import { connect } from "react-redux";

class OnboardManualFields extends React.Component {
  state = {
    hasAccountNumber: false,
  };

  constructor(props) {
    super(props);
    this.accountNumberField = React.createRef();
  }

  enableAccountNumber = () => {
    const { onChange } = this.props;

    this.setState({ hasAccountNumber: true });
    const accountNumber = this.getAccountNumber();
    onChange(accountNumber);
  };

  disableAccountNumber = () => {
    const { onChange } = this.props;

    this.setState({
      hasAccountNumber: false,
    });

    onChange(null);
  };

  getAccountNumber() {
    const field = this.accountNumberField;

    if (!field.current) {
      return;
    }

    return field.current.value;
  }

  handleChange = () => {
    const { onChange } = this.props;

    const accountNumber = this.getAccountNumber();
    onChange(accountNumber);
  };

  render() {
    const { otherCustodianStyles, appName } = this.props;

    const { hasAccountNumber } = this.state;

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormLabel>
              <Typography variant={"body1"} style={otherCustodianStyles}>
                Have you already established an account number?
              </Typography>
            </FormLabel>
            <RadioGroup row value={hasAccountNumber ? "1" : "0"}>
              <FormControlLabel
                checked={hasAccountNumber}
                control={<Radio />}
                label="Yes"
                onClick={this.enableAccountNumber}
                value="1"
              />
              <FormControlLabel
                checked={!hasAccountNumber}
                control={<Radio />}
                label="No"
                onClick={this.disableAccountNumber}
                value="0"
              />
            </RadioGroup>

            {hasAccountNumber && (
              <TextField
                InputLabelProps={{ shrink: true }}
                label="Enter Account Number"
                onChange={this.handleChange}
                inputRef={this.accountNumberField}
              />
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant={"body1"} style={otherCustodianStyles}>
            Please initiate the {appName} Account opening process by
            completing the forms on the following pages.
          </Typography>
          <Typography variant={"body1"} style={otherCustodianStyles}>
            In addition, your Custodian requires you to process their account
            opening paperwork as per your normal business procedures. Once you
            have been notified that your client’ s account has been established
            at your Custodian, please return to Cy to submit that account
            number to WBI for processing.
          </Typography>
          <Typography variant={"body1"} style={otherCustodianStyles}>
            Note: Your accounts cannot be traded until WBI has the customer’ s
            account number established at your Custodian.
          </Typography>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appName: state.app.appName,
  };
};

export default connect(mapStateToProps)(OnboardManualFields);



// WEBPACK FOOTER //
// ./src/components/OnboardManualFields/index.jsx